import React, { useEffect } from 'react';
import ReloadButton, { ReloadHandler } from '../Button/ReloadButton';

export interface LoadingErrorProps {
  error?: Error;
  message?: string;
  refresh?: ReloadHandler;
}

export const LoadingError = ({ message, error, refresh }: LoadingErrorProps) => {
  useEffect(() => {
    if (!error) return;
    console.error(error);
  }, [error]);
  return (
    <div className="grid w-screen h-screen place-items-center bg-grey-300 dark:bg-blue-1100">
      <div className="flex flex-col items-center max-w-lg text-center">
        <span className="mb-4 text-8xl material-symbols-outlined dark:text-white">error</span>

        <p className="mb-8 text-xl">
          {message ??
            'Something went wrong. Please reload page or contact support if error persists.'}
        </p>

        <ReloadButton text="Reload Page" reload={refresh} />
      </div>
    </div>
  );
};
